

export class CompanyRuleDetailsOutputWithOutStatus implements ICompanyRuleDetailsOutputWithOutStatus {
    /** The auto-generated id of the company rule details master */
    company_rule_detail_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The date of rule valid from */
    valid_from!: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    event_date_formate!: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    event_time_formate!: string;
    /** The device accuracy tolerance in meter */
    device_accuracy_tolerance!: number;
    /** The device distance variation should be "-" or  "+" */
    device_distance_variation!: string;
    /** The device distance variation percentage */
    device_distance_variation_percentage!: number;
    /** The POI tolerance */
    poi_tolerance!: number;
    /** The max speed validator */
    max_speed_validator!: number;
    /** The speed consideration moment */
    speed_consideration_moment!: number;
    /** The speed consideration moment */
    speed_tolerance!: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tour_start_buffer_time!: string;
    /** The sms alert from time should be in HH:mm:ss */
    sms_alert_from!: string;
    /** The sms alert to time should be in HH:mm:ss */
    sms_alert_to!: string;
    /** The inactive time */
    inactive_time!: number;
    /** The stoppage time */
    stoppage_time!: number;
    /** The idle time */
    idle_time!: number;
    /** The speed limit */
    speed_limit!: number;
    /** The ignition on first start should be 0 or 1 */
    ignition_on_first_start!: number;
    /** The show cluster should be 0 or 1 */
    show_cluster!: number;
    /** The report start time */
    report_start_time!: number;
    /** The report end time */
    report_end_time!: number;
    /** The sms reserved quantity */
    sms_reserved_quantity!: number;
    /** The welcome message with 500 character */
    welcome_message!: string;
    /** The authenticate should be 0 or 1 */
    authenticate!: number;
    /** The geofence alert should be 0 or 1 */
    geofence_alert!: number;
    /** The vehicle info1 should be 0 or 1 */
    vehicle_info_1!: number;
    /** The vehicleInfo description 1 with 500 character */
    vehicle_info_description_1!: string;
    /** The vehicle info2 should be 0 or 1 */
    vehicle_info_2!: number;
    /** The vehicleInfo description 2 with 500 character */
    vehicle_info_description_2!: string;
    /** The vehicle info3 should be 0 or 1 */
    vehicle_info_3!: number;
    /** The vehicleInfo description 3 with 500 character */
    vehicle_info_description_3!: string;
    /** The vehicle info4 should be 0 or 1 */
    vehicle_info_4!: number;
    /** The vehicleInfo description 4 with 500 character */
    vehicle_info_description_4!: string;
    /** The vehicle info5 should be 0 or 1 */
    vehicle_info_5!: number;
    /** The vehicleInfo description 5 with 500 character */
    vehicle_info_description_5!: string;
    status!: number;

    constructor(data?: ICompanyRuleDetailsOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_rule_detail_id = _data["company_rule_detail_id"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.valid_from = _data["valid_from"];
            this.event_date_formate = _data["event_date_formate"];
            this.event_time_formate = _data["event_time_formate"];
            this.device_accuracy_tolerance = _data["device_accuracy_tolerance"];
            this.device_distance_variation = _data["device_distance_variation"];
            this.device_distance_variation_percentage = _data["device_distance_variation_percentage"];
            this.poi_tolerance = _data["poi_tolerance"];
            this.max_speed_validator = _data["max_speed_validator"];
            this.speed_consideration_moment = _data["speed_consideration_moment"];
            this.speed_tolerance = _data["speed_tolerance"];
            this.tour_start_buffer_time = _data["tour_start_buffer_time"];
            this.sms_alert_from = _data["sms_alert_from"];
            this.sms_alert_to = _data["sms_alert_to"];
            this.inactive_time = _data["inactive_time"];
            this.stoppage_time = _data["stoppage_time"];
            this.idle_time = _data["idle_time"];
            this.speed_limit = _data["speed_limit"];
            this.ignition_on_first_start = _data["ignition_on_first_start"];
            this.show_cluster = _data["show_cluster"];
            this.report_start_time = _data["report_start_time"];
            this.report_end_time = _data["report_end_time"];
            this.sms_reserved_quantity = _data["sms_reserved_quantity"];
            this.welcome_message = _data["welcome_message"];
            this.authenticate = _data["authenticate"];
            this.geofence_alert = _data["geofence_alert"];
            this.vehicle_info_1 = _data["vehicle_info_1"];
            this.vehicle_info_description_1 = _data["vehicle_info_description_1"];
            this.vehicle_info_2 = _data["vehicle_info_2"];
            this.vehicle_info_description_2 = _data["vehicle_info_description_2"];
            this.vehicle_info_3 = _data["vehicle_info_3"];
            this.vehicle_info_description_3 = _data["vehicle_info_description_3"];
            this.vehicle_info_4 = _data["vehicle_info_4"];
            this.vehicle_info_description_4 = _data["vehicle_info_description_4"];
            this.vehicle_info_5 = _data["vehicle_info_5"];
            this.vehicle_info_description_5 = _data["vehicle_info_description_5"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyRuleDetailsOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRuleDetailsOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_rule_detail_id"] = this.company_rule_detail_id;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["valid_from"] = this.valid_from;
        data["event_date_formate"] = this.event_date_formate;
        data["event_time_formate"] = this.event_time_formate;
        data["device_accuracy_tolerance"] = this.device_accuracy_tolerance;
        data["device_distance_variation"] = this.device_distance_variation;
        data["device_distance_variation_percentage"] = this.device_distance_variation_percentage;
        data["poi_tolerance"] = this.poi_tolerance;
        data["max_speed_validator"] = this.max_speed_validator;
        data["speed_consideration_moment"] = this.speed_consideration_moment;
        data["speed_tolerance"] = this.speed_tolerance;
        data["tour_start_buffer_time"] = this.tour_start_buffer_time;
        data["sms_alert_from"] = this.sms_alert_from;
        data["sms_alert_to"] = this.sms_alert_to;
        data["inactive_time"] = this.inactive_time;
        data["stoppage_time"] = this.stoppage_time;
        data["idle_time"] = this.idle_time;
        data["speed_limit"] = this.speed_limit;
        data["ignition_on_first_start"] = this.ignition_on_first_start;
        data["show_cluster"] = this.show_cluster;
        data["report_start_time"] = this.report_start_time;
        data["report_end_time"] = this.report_end_time;
        data["sms_reserved_quantity"] = this.sms_reserved_quantity;
        data["welcome_message"] = this.welcome_message;
        data["authenticate"] = this.authenticate;
        data["geofence_alert"] = this.geofence_alert;
        data["vehicle_info_1"] = this.vehicle_info_1;
        data["vehicle_info_description_1"] = this.vehicle_info_description_1;
        data["vehicle_info_2"] = this.vehicle_info_2;
        data["vehicle_info_description_2"] = this.vehicle_info_description_2;
        data["vehicle_info_3"] = this.vehicle_info_3;
        data["vehicle_info_description_3"] = this.vehicle_info_description_3;
        data["vehicle_info_4"] = this.vehicle_info_4;
        data["vehicle_info_description_4"] = this.vehicle_info_description_4;
        data["vehicle_info_5"] = this.vehicle_info_5;
        data["vehicle_info_description_5"] = this.vehicle_info_description_5;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICompanyRuleDetailsOutputWithOutStatus {
    /** The auto-generated id of the company rule details master */
    company_rule_detail_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The date of rule valid from */
    valid_from: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    event_date_formate: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    event_time_formate: string;
    /** The device accuracy tolerance in meter */
    device_accuracy_tolerance: number;
    /** The device distance variation should be "-" or  "+" */
    device_distance_variation: string;
    /** The device distance variation percentage */
    device_distance_variation_percentage: number;
    /** The POI tolerance */
    poi_tolerance: number;
    /** The max speed validator */
    max_speed_validator: number;
    /** The speed consideration moment */
    speed_consideration_moment: number;
    /** The speed consideration moment */
    speed_tolerance: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tour_start_buffer_time: string;
    /** The sms alert from time should be in HH:mm:ss */
    sms_alert_from: string;
    /** The sms alert to time should be in HH:mm:ss */
    sms_alert_to: string;
    /** The inactive time */
    inactive_time: number;
    /** The stoppage time */
    stoppage_time: number;
    /** The idle time */
    idle_time: number;
    /** The speed limit */
    speed_limit: number;
    /** The ignition on first start should be 0 or 1 */
    ignition_on_first_start: number;
    /** The show cluster should be 0 or 1 */
    show_cluster: number;
    /** The report start time */
    report_start_time: number;
    /** The report end time */
    report_end_time: number;
    /** The sms reserved quantity */
    sms_reserved_quantity: number;
    /** The welcome message with 500 character */
    welcome_message: string;
    /** The authenticate should be 0 or 1 */
    authenticate: number;
    /** The geofence alert should be 0 or 1 */
    geofence_alert: number;
    /** The vehicle info1 should be 0 or 1 */
    vehicle_info_1: number;
    /** The vehicleInfo description 1 with 500 character */
    vehicle_info_description_1: string;
    /** The vehicle info2 should be 0 or 1 */
    vehicle_info_2: number;
    /** The vehicleInfo description 2 with 500 character */
    vehicle_info_description_2: string;
    /** The vehicle info3 should be 0 or 1 */
    vehicle_info_3: number;
    /** The vehicleInfo description 3 with 500 character */
    vehicle_info_description_3: string;
    /** The vehicle info4 should be 0 or 1 */
    vehicle_info_4: number;
    /** The vehicleInfo description 4 with 500 character */
    vehicle_info_description_4: string;
    /** The vehicle info5 should be 0 or 1 */
    vehicle_info_5: number;
    /** The vehicleInfo description 5 with 500 character */
    vehicle_info_description_5: string;
    status: number;
}

